/* hs-eslint ignored failing-rules */

/* eslint-disable promise/catch-or-return */
'use es6';

import { jsxs as _jsxs } from "react/jsx-runtime";
import { jsx as _jsx } from "react/jsx-runtime";
import { Component } from 'react';
import PropTypes from 'prop-types';
import { List } from 'immutable';
import UITable from 'UIComponents/table/UITable';
import UISortTH from 'UIComponents/table/UISortTH';
import UILoadingSpinner from 'UIComponents/loading/UILoadingSpinner';
import SimpleHubPickerRow from './SimpleHubPickerRow';
import I18n from 'I18n';
import UIErrorMessage from 'UIComponents/error/UIErrorMessage';
import RequestStatusTypes from 'hub-pickers-lib/constants/RequestStatusTypes';
import links, { redirectLink } from '../utils/links';
import { getAccountsCrossHublet } from '../Accounts/AccountFetcher';
import { sortByField, sortByNumericalField } from 'hub-pickers-lib/utils/sorts';

class SimpleHubPicker extends Component {
  constructor(...args) {
    super(...args);
    this.state = {
      accounts: List(),
      accountsRequestStatus: RequestStatusTypes.UNINITIALIZED,
      sortField: '',
      sortDir: ''
    };

    this.getFilteredAccounts = () => {
      if (!this.props.filter) {
        return this.state.accounts;
      }

      const filter = this.props.filter.toLowerCase();
      return this.state.accounts.filter(account => account.accountName.toLowerCase().includes(filter) || account.domain.toLowerCase().includes(filter) || account.id.toString().includes(filter));
    };

    this.onSortChange = field => {
      return event => {
        const sortedAccounts = this.state.accounts.sort(sortByField(field, event.target.value));
        this.setState({
          sortDir: event.target.value,
          sortField: field,
          accounts: sortedAccounts
        });
      };
    };

    this.onNumericalSortChange = field => {
      return event => {
        const sortedAccounts = this.state.accounts.sort(sortByNumericalField(field, event.target.value));
        this.setState({
          sortDir: event.target.value,
          sortField: field,
          accounts: sortedAccounts
        });
      };
    };

    this.renderLoader = () => {
      return /*#__PURE__*/_jsx("tr", {
        children: /*#__PURE__*/_jsx("td", {
          colSpan: 3,
          children: /*#__PURE__*/_jsx(UILoadingSpinner, {
            grow: true,
            minHeight: 50
          })
        })
      });
    };

    this.renderTableContents = () => {
      const filteredAccounts = this.getFilteredAccounts();

      if (filteredAccounts.size === 0) {
        return /*#__PURE__*/_jsx("tr", {
          className: "empty-accounts-table",
          children: /*#__PURE__*/_jsx("td", {
            colSpan: 3,
            children: I18n.text('hubPicker.noFilteredResults')
          })
        });
      }

      return filteredAccounts.map((account, key) => {
        return /*#__PURE__*/_jsx(SimpleHubPickerRow, {
          account: account,
          pinned: true,
          onPinChange: this.onPinChange,
          query: this.props.query,
          redirectTo: this.props.redirectTo
        }, key);
      });
    };
  }

  componentDidMount() {
    getAccountsCrossHublet(false, false).then(payload => {
      this.setState(Object.assign({}, payload));
    });
  }

  render() {
    const {
      accounts,
      accountsRequestStatus,
      sortField,
      sortDir
    } = this.state;
    const loading = accountsRequestStatus === RequestStatusTypes.PENDING || accountsRequestStatus === RequestStatusTypes.UNINITIALIZED;

    if (accountsRequestStatus === RequestStatusTypes.FAILED) {
      return /*#__PURE__*/_jsx(UIErrorMessage, {
        type: "badRequest",
        children: /*#__PURE__*/_jsx("p", {
          children: I18n.text('error.requestFailed.description')
        })
      });
    } else if (!loading && accounts.size === 0) {
      return /*#__PURE__*/_jsx(UIErrorMessage, {
        illustration: "cone",
        type: "expired",
        children: /*#__PURE__*/_jsx("p", {
          children: I18n.text('error.noAccounts.description')
        })
      });
    }

    return /*#__PURE__*/_jsxs(UITable, {
      className: "account-picker",
      children: [/*#__PURE__*/_jsx("thead", {
        children: /*#__PURE__*/_jsxs("tr", {
          children: [/*#__PURE__*/_jsx(UISortTH, {
            className: "name",
            sort: sortField === 'accountName' ? sortDir : 'none',
            onSortChange: this.onSortChange('accountName'),
            children: I18n.text('hubPicker.name')
          }), /*#__PURE__*/_jsx(UISortTH, {
            className: "domain",
            sort: sortField === 'domain' ? sortDir : 'none',
            onSortChange: this.onSortChange('domain'),
            children: I18n.text('hubPicker.domain')
          })]
        })
      }), /*#__PURE__*/_jsx("tbody", {
        children: loading ? this.renderLoader() : this.renderTableContents()
      })]
    });
  }

}

SimpleHubPicker.propTypes = {
  redirectTo: redirectLink,
  query: PropTypes.object,
  filter: PropTypes.string
};
SimpleHubPicker.defaultProps = {
  redirectTo: links.homeService,
  query: {},
  filter: ''
};
export default SimpleHubPicker;